// Shared calendar/date helpers
export const MONTHS=["January","February","March","April","May","June","July","August","September","October","November","December"];
export const SM=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const WD=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
export const daysIn=(y,m)=>new Date(y,m+1,0).getDate();
export const firstDay=(y,m)=>new Date(y,m,1).getDay();
export const fmtKey=(y,m,d)=>`${y}-${String(m+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
export const fmtDisp = (s) => {
  if (!s || s === 'undefined' || s === 'null') return '-';
  try {
    const raw = String(s);
    // Avoid timezone shift: treat YYYY-MM-DD as local date
    const ymd = raw.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      const [y, m, d] = ymd.split('-').map(n => parseInt(n, 10));
      const dt = new Date(y, (m || 1) - 1, d || 1);
      return `${SM[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
    }
    const dt = new Date(raw);
    if (isNaN(dt.getTime())) return '-';
    return `${SM[dt.getMonth()]} ${dt.getDate()}, ${dt.getFullYear()}`;
  } catch {
    return '-';
  }
};
export const R="\u20B9";

// Central date-only formatter — use everywhere instead of toLocaleString/toLocaleTimeString
// Returns e.g. "15 Mar 2025"  — never includes time
export const dateOnly = (value) => {
  if (!value && value !== 0) return '-';
  try {
    const raw = String(value).trim();
    // Pure date string YYYY-MM-DD — avoid timezone shift
    const ymd = raw.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      const [y, m, d] = ymd.split('-').map(Number);
      const dt = new Date(y, m - 1, d);
      if (isNaN(dt.getTime())) return '-';
      return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    }
    const dt = new Date(raw);
    if (isNaN(dt.getTime())) return '-';
    return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return '-'; }
};

export const formatDateOnly = (value, locale = "en-IN") => {
  if (!value && value !== 0) return "-";
  try {
    const raw = String(value).trim();
    const ymd = raw.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      const [y, m, d] = ymd.split("-").map((n) => parseInt(n, 10));
      const dt = new Date(y, (m || 1) - 1, d || 1);
      if (isNaN(dt.getTime())) return "-";
      return dt.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
    }
    const dt = new Date(raw);
    if (isNaN(dt.getTime())) return "-";
    return dt.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
  } catch (_) {
    return "-";
  }
};
